import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import WhatsAppButton from './components/WhatsAppButton';
import CookieBanner from './components/CookieBanner';
import AIChatbot from './components/AIChatbot';
import ScrollProgress from './components/ScrollProgress';
import Analytics from './components/Analytics';
import SkipToContent from './components/SkipToContent';
import { LanguageProvider } from './i18n/LanguageContext';
import './App.css';

// Code splitting : les pages secondaires sont chargées à la demande
const ServicesPage = lazy(() => import('./pages/ServicesPage'));
const NiroprodPage = lazy(() => import('./pages/NiroprodPage'));
const WhyUsPage = lazy(() => import('./pages/WhyUsPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const TechmillPage = lazy(() => import('./pages/TechmillPage'));
const LegalPage = lazy(() => import('./pages/LegalPage'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'));
const BlogPage = lazy(() => import('./pages/BlogPage'));
const BlogArticlePage = lazy(() => import('./pages/BlogArticlePage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

const PageLoader = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: 'var(--dark)'
  }}>
    <div className="page-loader" aria-label="Chargement">
      <div className="page-loader__dot"></div>
      <div className="page-loader__dot"></div>
      <div className="page-loader__dot"></div>
    </div>
  </div>
);

const MainLayout = ({ children }) => (
  <>
    <Navbar />
    <div id="main-content">{children}</div>
    <Footer />
    <WhatsAppButton />
    <AIChatbot />
  </>
);

const App = () => {
  return (
    <LanguageProvider>
      <Router>
        <SkipToContent />
        <ScrollProgress />
        <Analytics />
        <CookieBanner />
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/techmill" element={<TechmillPage />} />
            <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
            <Route path="/services" element={<MainLayout><ServicesPage /></MainLayout>} />
            <Route path="/niroprod" element={<MainLayout><NiroprodPage /></MainLayout>} />
            <Route path="/pourquoi-nous" element={<MainLayout><WhyUsPage /></MainLayout>} />
            <Route path="/contact" element={<MainLayout><ContactPage /></MainLayout>} />
            <Route path="/blog" element={<MainLayout><BlogPage /></MainLayout>} />
            <Route path="/blog/:slug" element={<MainLayout><BlogArticlePage /></MainLayout>} />
            <Route path="/mentions-legales" element={<MainLayout><LegalPage /></MainLayout>} />
            <Route path="/confidentialite" element={<MainLayout><PrivacyPage /></MainLayout>} />
            <Route path="*" element={<MainLayout><NotFoundPage /></MainLayout>} />
          </Routes>
        </Suspense>
      </Router>
    </LanguageProvider>
  );
};

export default App;
